(function() {
  'use strict';

  angular.module('app').controller('SettingsMenuController', SettingsMenuController);

  SettingsMenuController.$inject = [
    '$rootScope',
    '$scope',
    '$routeParams',
    '$timeout',
    '$location',
    '$filter',
    'blockUI',
    '$uibModal',
    'NotifyService',
    'BusinessService'
  ];

  function SettingsMenuController($rootScope, $scope,
      $routeParams,
      $timeout,
      $location,
      $filter,
      blockUI,
      $uibModal,
      NotifyService,
      BusinessService
  ) {

    // var menuItems = $rootScope.defaultMenu;
    $scope.data = {};
    $scope.data.menuItems = null;

    var mainPageBlock = blockUI.instances.get('settings_menu_page'),
        mainListBlock = blockUI.instances.get('settings_menu_list');
    $rootScope.$watch('MENU_ITEMS', function(newValue, oldValue) {

      $scope.data.menuItems = deepMap((angular.copy(newValue) || []), function(item) {
        item.hidden = !!item.hidden;
        return item;
      }, 'sub');
    });

    $scope.onResetOrdering = function() {
      BusinessService.SetSettingsMenu({itemsOrdering: null}, function(success, data) {
        if (success) {
          // $scope.data.menuItems = angular.copy($rootScope.getDefaultMenu());
          $rootScope.MENU_ITEMS = $scope.data.menuItems = deepMap((angular.copy($rootScope.getDefaultMenu()) || []), function(item) {
            item.hidden = !!item.hidden;
            return item;
          }, 'sub');
          NotifyService.Success('', false);
        }
      });

      $scope.data.menuItems = angular.copy($rootScope.getDefaultMenu());
    };

    $scope.onSettingsSave = function() {
      mainListBlock.start();

      var itemsOrdering = prepareSaveItems(angular.copy($scope.data.menuItems));

      BusinessService.SetSettingsMenu({itemsOrdering: itemsOrdering}, function(success, data) {
        if (success) {
          $rootScope.MENU_ITEMS = angular.copy($scope.data.menuItems);
          NotifyService.Success('', false);
        }
        mainListBlock.stop();
      });
    };

    function prepareSaveItems(items) {
      return items.map(function(item) {

        var saveItem = {
          keyGuard: item.keyGuard,
          hidden: !!item.hidden
        };

        if (!!item.sub && item.sub.length > 0) {
          saveItem.sub = prepareSaveItems(item.sub);
        }
        return saveItem;
      });
    }

  }
})();
